/**
 * The study header's "Edit details" action: offered when the shell has a
 * details editor to open (enterprise), the study's public id is known, and the
 * page knows the person may write the study. While the rights are still being
 * asked (`readOnly` undefined), and for a viewer, nothing is offered.
 */
export function editDetailsAction(
  open: ((studyId: string) => void) | undefined,
  studyId: string | undefined,
  readOnly: boolean | undefined,
): (() => void) | undefined {
  return open && studyId && readOnly === false ? () => open(studyId) : undefined;
}
